import Vue from "vue";
import VueRouter from "vue-router";
import Api from '@/core/Api';
import { parcoursUrl, PARCOURS_BASE_URL } from '@/core/parcours';
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: '/home',
    component: () => import( "@/views/layout/Main.vue"),
    children:[
      {
        path:'/home',
        name: 'Accueil',
        component: () => import( "@/views/Home.vue"),
        meta:{
          logged:true
        }
      },   
      {
        path:'/whatsapp',
        name: 'WhatsApp',
        component: () => import( "@/views/WhatsApp.vue"),
        meta:{
          logged:true
        }
      },
      /* Statistiques du parcours client.
       *
       * Sous `/parcours` (avec un S) et NON sous `/parcour`, qui est le bloc
       * public du parcours lui-même : celui-ci vit hors du layout et ne fait
       * plus que rediriger vers le site Twig. Un écran de suivi doit rester
       * derrière l'authentification, donc ici, dans les enfants de `/`.
       */
      {
        path:'/parcours/stats',
        name: 'Statistiques du parcours',
        component: () => import( "@/views/parcour/Stats.vue"),
        meta:{
          logged:true
        }
      },
      {
        path:'/bibliotheque',
        name: 'Bibliothèque',
        component: () => import( "@/views/Bibliotheque.vue"),
        meta:{
          logged:true
        }
      },
      {
        path:'/param',        
        component: () => import( "@/views/param/Main.vue"),
        children:[
          {
            path:'liste',
            name: 'Parametrage',
            component: () => import( "@/views/param/Liste.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'model/:name',
            name: 'Model',
            component: () => import( "@/views/param/Model.vue"),
            meta:{
              logged:true
            }
          },
        ]
      },
      {
        path:'/utilisateur',
        name: 'Utilisateur',
        component: () => import( "@/views/utilisateur/Main.vue"),
        children:[
          {
            path:'nouveau',
            name:'Nouvelle utilisateur',
            component: () => import( "@/views/utilisateur/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'detail/:id',
            name:'Detail de l\'utilisateur',
            component: () => import( "@/views/utilisateur/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'liste',
            name:'Liste des utilisateurs',
            component: () => import( "@/views/utilisateur/Liste.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'rdp',
            name: 'RDP',
            component: () => import( "@/views/utilisateur/RDP.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'vpn',
            name: 'VPN',
            component: () => import( "@/views/utilisateur/VPN.vue"),
            meta:{
              logged:true
            }
          },
        ]
      },
      {
        path:'/prospect',
        name: 'Prospect',
        component: () => import( "@/views/prospect/Main.vue"),
        children:[
          {
            path:'nouveau',
            name:'Nouveau prospect',
            component: () => import( "@/views/prospect/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'detail/:id',
            name:'Detail du prospect',
            component: () => import( "@/views/prospect/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'liste',
            name:'Liste des prospect',
            component: () => import( "@/views/prospect/Liste.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'fake',
            name:'Liste des fake',
            component: () => import( "@/views/prospect/Fake.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'appel/:phone',
            name:'Appel entrant',
            component: () => import( "@/views/prospect/Appel.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'stats',
            name:'Liste des stats',
            component: () => import( "@/views/prospect/Stats.vue"),
            meta:{
              logged:true
            }
          },
        ]
      },
      {
        path:'/reclamation',
        name: 'Reclamation',
        component: () => import( "@/views/reclamation/Main.vue"),
        children:[          
          {
            path:'liste',
            name:'Liste des reclamations',
            component: () => import( "@/views/reclamation/Liste.vue"),
            meta:{
              logged:true
            }
          }          
        ]
      },
      {
        path:'/pbx',
        name: 'PBX',
        component: () => import( "@/views/pbx/Main.vue"),
        children:[
          {
            path:'liste',
            name:'Liste des appels',
            component: () => import( "@/views/pbx/Liste.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },
      {
        path:'/sms',
        name: 'SMS',
        component: () => import( "@/views/sms/Main.vue"),
        children:[
          {
            path:'liste',
            name:'Liste des sms',
            component: () => import( "@/views/sms/Liste.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },
      {
        path:'/devis',
        name: 'Devis',
        component: () => import( "@/views/devis/Main.vue"),
        children:[
          {
            path:'nouveau/:id',
            name:'Nouveau devis',
            component: () => import( "@/views/devis/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'detail/:id',
            name:'Detail du devis',
            component: () => import( "@/views/devis/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'liste',
            name:'Liste des devis',
            component: () => import( "@/views/devis/Liste.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'contrat/:id',
            name:'Nouveau contrat',
            component: () => import( "@/views/devis/Contrat.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },
      {
        path:'/produit',
        name: 'Produit',
        component: () => import( "@/views/produit/Main.vue"),
        children:[
          {
            path:'nouveau',
            name:'Nouveau produit',
            component: () => import( "@/views/produit/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'detail/:id',
            name:'Detail du produit',
            component: () => import( "@/views/produit/Nouveau.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'liste',
            name:'Liste des produits',
            component: () => import( "@/views/produit/Liste.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'manquant',
            name:'Liste des produits manquant',
            component: () => import( "@/views/produit/Manquant.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },
      {
        path:'/mutuelle',
        name: 'Mutuelle',
        component: () => import( "@/views/mutuelle/Main.vue"),
        children:[          
          {
            path:'liste',
            name:'Liste des mutuelles',
            component: () => import( "@/views/mutuelle/Liste.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },
      {
        path:'/agenda',
        name: 'Agenda',
        component: () => import( "@/views/agenda/Main.vue"),
        children:[
          {
            path:'mois',
            name:'Agenda par mois',
            component: () => import( "@/views/agenda/Mois.vue"),
            meta:{
              logged:true
            }
          },
          {
            path:'semaine',
            name:'Agenda par semaine',
            component: () => import( "@/views/agenda/Semaine.vue"),
            meta:{
              logged:true
            }
          }
        ]
      },  
      {
        path:'/source',
        name: 'Source',
        component: () => import( "@/views/source/Main.vue"),
        children:[
          {
            path:'liste',
            name:'SourceListe',
            component: () => import( "@/views/source/Liste.vue"),
            meta:{
              logged:true
            }
          },          
        ]
      },      
      {
        path:'/distribution',
        name: 'Distribution',        
        component: () => import( "@/views/Distribution.vue"),
        meta:{
          logged:true
        }
      },      
    ]
  },  
  {
    path:'/login',
    name: 'Login',
    component: () => import( "@/views/Login.vue"),
    meta:{
      logged:false
    }
  },
  {
    path: "/document",
    component: () => import( "@/views/document/Main.vue"),
    children:[
      {
        path:'pdf',
        name: 'DocumentPDF',
        component: () => import( "@/views/document/PDF.vue"),
        meta:{
          logged:false
        }
      },
      {
        path:'f/:uuid',
        name: 'DocumentCommande',
        component: () => import( "@/views/document/File.vue"),
        meta:{
          logged:false
        }
      },
      {
        path:'test',
        name: 'DocumentTest',
        component: () => import( "@/views/document/Test.vue"),
        meta:{
          logged:false
        }
      }      
    ]
  },
  {
    path:'/parrainage/:code',
    name:'Parrainage',
    component: () => import( "@/views/Parrainage.vue"),
    meta:{
      logged:false
    }
  },
  {
    path:'/campagne/:q',
    name:'Campagne',
    component: () => import( "@/views/Campagne.vue"),
    meta:{
      logged:false
    }
  },
  {
    path:'/rdv/:token',
    name:'Nouveau RDV',
    component: () => import( "@/views/RDV.vue"),
    meta:{
      logged:false
    }
  },
  /* Parcours client — REDIRECTION vers le site public.
   *
   * Le parcours n'est plus servi par le CRM : il vit en Twig sur
   * assureur-francais.fr (voir `export-twig/`), seule version maintenue
   * depuis la divergence du 27/08/2026. Les deux routes sont conservées
   * parce que des liens sont déjà partis chez des prospects ; elles ne font
   * plus qu'emmener vers la bonne adresse.
   *
   * `ClientV2.vue` n'est plus monté par personne mais reste en place : il
   * suffit de retirer les deux `beforeEnter` pour revenir en arrière.
   *
   * Une redirection EXTERNE ne peut pas passer par `redirect:`, qui ne sait
   * viser que des routes internes — d'où `window.location.replace`. On
   * n'appelle volontairement pas `next()` : la navigation interne doit
   * rester en suspens pendant que le navigateur change de page, sans quoi
   * le composant serait monté pour rien le temps du chargement. `replace`
   * plutôt que `assign` pour ne pas piéger le bouton Retour sur une URL qui
   * ne fait que rebondir.
   */
  {
    path: "/parcour",
    component: () => import( "@/views/parcour/Main.vue"),
    children:[
      {
        path:'client/:api',
        name: 'Parcour Client',
        component: () => import( "@/views/parcour/ClientV2.vue"),
        beforeEnter(to){
          window.location.replace(parcoursUrl(to.params.api) || PARCOURS_BASE_URL);
        },
        meta:{
          logged:false
        }
      },
      {
        path:'clientv2/:api',
        name: 'Parcour Client V2',
        component: () => import( "@/views/parcour/ClientV2.vue"),
        beforeEnter(to){
          window.location.replace(parcoursUrl(to.params.api) || PARCOURS_BASE_URL);
        },
        meta:{
          logged:false,
          layout: 'BlankLayout'
        }
      },
    ]
  },
  { 
    path: "*",
    redirect: "/agenda/mois"
  },
];
async function backVerify(){
  var option = {
    "headers":{
      "Content-Type":"application/json",
      "Authorization": Api.getToken()
    }
  };
  var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var url = Api.url.api + '/authorization/verify?timezone=' + tz;
  var response = await fetch(url,option);
  var res = await response.json();  
  return res;
}
async function getParams(){
  var option = {
    "headers":{
      "Content-Type":"application/json",
      "Authorization": Api.getToken()
    }
  };
  var url = Api.url.api + '/param/all'
  var response = await fetch(url,option);
  var res = await response.json();
  return res;
}
const router = new VueRouter({
  routes,
});
router.beforeEach( async (to, from, next) => {
  if(to.meta.logged === true){
    if(Api.params === false){
      await getParams().then(res => {
        if(res.status){
          if(res.data.Societe != undefined){
            res.data.Societe.forEach((item) => {
              item.titre = item.raison_sociale
            });
          }
          Api.params = res.data
        }
      });
    }
    if(Api.getToken() != false){
      await backVerify().then(res => {
        if(res.status === true){
          Api.saveToken(res.data.token);
          Api.saveUser(res.data);
          next();
        }else{
          next({path:'/login', replace:true})
        }
      }).catch( () => {
        next({path:'/login'})
      });
    }else{
      next({path:'/login'})
    }
  }else{
    next();
  }
})

export default router;
